import { API_PATHS } from "../constants/api-paths";
import { COMMON_SSO_MOBILE } from "../constants/sso";
import { decryptLocalStorageMobileNo } from "@repo/shared-utils/crypto";
import { IResponse, encryptedRequest } from "../core/api.client";

// Local type - not exported to avoid naming conflicts
type IApiResponseRewardsPoints = {
  totalPoints: string;
  totalPointsValue: string;
};

export const getRewardsPoints = async (): Promise<IResponse<IApiResponseRewardsPoints>> => {
  const localStorageMobileNo = localStorage.getItem(COMMON_SSO_MOBILE);
  const mobileNo = await decryptLocalStorageMobileNo(localStorageMobileNo || "");
  const response = await encryptedRequest<IApiResponseRewardsPoints>({
    method: "POST",
    url: API_PATHS.rewardsPoints,
    data: {
      mobileNo,
    },
  });

  if (response.statusCode !== 90) {
    throw new Error(response.message);
  }

  return response;
};
